/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- COMMENTING ANALYTICS - TOTAL COMMENTS REPORT : STYLES --------------- ++++++++++ */
export default {
    totalcommentsreport: {
        marginBottom: pxToEm(16)
    }
};
